<template>
    <div>
        <Col span="5" class="conLeftTwo">
        <div class="top">
            <RadioGroup v-model="button" type="button" size="small" v-on:on-change='changeValue'>
                <Radio label="个人权限" style="height: 30px;line-height: 30px;">个人权限</Radio>
                <Radio label="权限组" style="height: 30px;line-height: 30px;padding: 0 27px;">权限组</Radio>
            </RadioGroup>
        </div>
        <div class="main" v-if="button==='权限组'">
            <ul>
                <li v-for="(item,key) in RolesList" :key="key" :class="{selected:item.id === curMember}" @click="changeMember(item.id)">
                    <Icon type="person-stalker"></Icon>
                    {{item.alias}}
                    <div v-if="permissionRoleUpdate" @click.stop="titleShow" style="display: inline;width: 30px">
                        <Icon v-if="item.id === curMember" style="float: right;display: inline-block;width: 30px;text-align: center;margin-right: -10px;"
                            type="android-more-vertical"></Icon>
                    </div>
                    <div v-if="isShow && item.id === curMember" class="rolesModel">
                        <div style="border-bottom: 1px solid #dddee1" @click="modal1 = true">修改名字</div>
                        <div @click="modal2 = true">删除</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="main" v-if="button==='个人权限'">
            <ul>
                <li v-for="(item,key) in memberList" :key="key" :class="{selected:item.id ===  curPerson}" @click="changeMember(item.id)">
                    <Icon type="person"></Icon>
                    {{item.fullname}}
                </li>
            </ul>
            <Page v-if="button==='个人权限'" style="position: absolute;top:600px;" :current="page" :total="total"
                :page-size="15" size="small" v-on:on-change="getMemberList"></Page>
        </div>
        </Col>
        <Col span="19" class="conRight">
        <div class="permissionTop">
            <p class="tittle-lv1">管理权限</p>
            <div>
                <Select  style="width:200px" size="small" placeholder="选择角色" v-if="button==='个人权限'">
                    <Option v-for="(item,key) in RolesList" :key="key" :value="item.alias" @click.native="changeRole(item.id)">{{
                        item.alias }}</Option>
                </Select>
                <Button type="primary" v-if="'web_permission_add'" size="small" @click="addRoutes">添加权限组</Button>
            </div>
        </div>
        <div class="mainNav" style="margin-top: 5px">
            <div :class="tabChange === 1 ? 'title-lv2' : 'title-lv3'" @click="tabsChange(1)">应用端</div>
            <div :class="tabChange === 2 ? 'title-lv2' : 'title-lv3'" @click="tabsChange(2)">APP端</div>
            <div :class="tabChange === 3 ? 'title-lv2' : 'title-lv3'" @click="tabsChange(3)">WEB端</div>
        </div>
        <div v-if="tabChange===1" class="mainContent">
            <!--<p class="topName">{{$store.getters.comInfo.contact}} <span>超级管理员</span></p>-->
            <Form :model="formItem">
                <FormItem>
                    <Scroll height="520" style="border-bottom: 1px solid #dddee1">
                        <div v-for="(item,key) in itemList" :key="key">
                            <div class="mainNav" style="background-color: #f8f8f9;border: 0;line-height: 28px;font-weight: bold">{{item.title}}
                                <div class="iv-icon-down" @click="showPermiss(item.id)">
                                    <Icon v-if="item.access" type="chevron-down"></Icon>
                                    <Icon v-if="!item.access" type="chevron-right"></Icon>
                                </div>
                            </div>
                            <div v-for="(items,key) in item.children" :key="key" :class="item.access ? 'showCheck' :  'hideCheck'">
                                <div style="padding-top:6px;margin-top:6px;margin-left: 20px;">
                                    <Checkbox :indeterminate="auths[items.id].indeterminate" :value="auths[items.id].checkAll"
                                        @click.prevent.native="handleCheckAll(items.id)" :key="items.id">{{items.title}}</Checkbox>
                                </div>
                                <CheckboxGroup v-model="formItem.checkbox" @on-change="checkAllGroupChange" v-if="items !== item.children[item.children.length -1]"
                                    style="border-bottom: 1px dashed #e9e9e9;">
                                    <Checkbox style="font-weight: 100;margin-left: 20px;" v-for="(res,key) in items.children"
                                        :key="key" :label="res.title"></Checkbox>
                                </CheckboxGroup>
                                <CheckboxGroup v-model="formItem.checkbox" @on-change="checkAllGroupChange" v-if="items === item.children[item.children.length -1]">
                                    <Checkbox style="font-weight: 100;margin-left: 20px;" v-for="(res,key) in items.children"
                                        :key="key" :label="res.title"></Checkbox>
                                </CheckboxGroup>
                            </div>
                        </div>
                        <!--CRM-->
                        <!--<TabPane label="CRM" name="name2">-->
                        <!--<CheckboxGroup v-model="formItem.checkbox" @on-change="crmcheckAllGroupChange">-->
                        <!--<Checkbox v-for="item in CrmList" :label="item.alias"></Checkbox>-->
                        <!--</CheckboxGroup>-->
                        <!--</TabPane>-->
                    </Scroll>
                </FormItem>
            </Form>
            <Checkbox style="margin-top: 5px" v-model="single">全部选择</Checkbox>
            <Button v-if="button==='个人权限' && permissionUpdate" style="float: right" @click="confirmUpdate(1)" type="primary">确认修改</Button>
            <Button v-if="button==='权限组' && permissionRoles" style="float: right" @click="confirmRoles(1)" type="primary">确认修改</Button>
        </div>
        <div v-if="tabChange===2" class="mainContent">
            <!--<p class="topName">{{$store.getters.comInfo.contact}} <span>超级管理员</span></p>-->
            <Form :model="formItem">
                <FormItem>
                    <div style="font-size: 24px;font-weight: bold;text-align: center;height: 520px;line-height: 520px">我是CRM权限，暂时不设置任何权限</div>
                </FormItem>
            </Form>
            <Checkbox style="margin-top: 5px" v-model="single">全部选择</Checkbox>
            <Button v-if="button==='个人权限' && permissionUpdate" style="float: right" @click="confirmUpdate(2)" type="primary">确认修改</Button>
            <Button v-if="button==='权限组' && permissionRoles" style="float: right" @click="confirmRoles(2)" type="primary">确认修改</Button>
        </div>
        <div v-if="tabChange===3" class="mainContent">
            <!--<p class="topName">{{$store.getters.comInfo.contact}} <span>超级管理员</span></p>-->
            <Form :model="formItem">
                <Scroll height="520" style="border-bottom: 1px solid #dddee1">
                    <FormItem>
                        <div v-for="(items,key) in webList" :key="key">
                            <div style="padding-top:6px;margin-top:6px;">
                                <Checkbox :indeterminate="webAuths[items.id].indeterminate" :value="webAuths[items.id].checkAll"
                                    @click.prevent.native="webhandleCheckAll(items.id)" :key="items.id">{{items.title}}</Checkbox>
                            </div>
                            <CheckboxGroup v-model="formItem.webCheckbox" style="border-bottom: 1px solid #e9e9e9;"
                                @on-change="webcheckAllGroupChange">
                                <Checkbox style="font-weight: 100;" v-for="(res,key) in items.children" :key="key"
                                    :label="res.title"></Checkbox>
                            </CheckboxGroup>
                        </div>
                    </FormItem>
                </Scroll>
            </Form>
            <Checkbox style="margin-top: 15px" v-model="webSingle">全部选择</Checkbox>
            <Button v-if="button==='个人权限' && permissionUpdate" style="float: right;margin-top: 15px" @click="confirmUpdate(3)"
                type="primary">确认修改</Button>
            <Button v-if="button==='权限组' && permissionRoles" style="float: right;margin-top: 15px" @click="confirmRoles(3)"
                type="primary">确认修改</Button>
        </div>

        </Col>
        <!--修改权限组名称-->
        <Modal v-model="modal1" title="修改权限组名称" @on-ok="ok">
            <Form :model="formItem" :label-width="80">
                <FormItem label="权限组名称">
                    <Input v-model="formItem.input" placeholder="权限组名称"></Input>
                </FormItem>
            </Form>
        </Modal>

        <!--确认删除-->
        <Modal v-model="modal2" width="360">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>删除权限组</span>
            </p>
            <div style="text-align:center">
                <p>权限组删除之后将无法恢复,您确定要删除吗?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long @click="del">删除</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {HOST} from '../../../config';

    export default {
        name: 'permission',
        data() {
            return {
                theme1: 'light',
                formItem: {
                    checkbox: [],
                    input: '',
                    webCheckbox: [],
                },
                modal1: false,
                modal2: false,
                itemList: [],
                webList: [],
                CrmList: [],
                memberList: [],
                RolesList: [],
                classA: true,
                auth: [],
                auths: [],
                webAuth: [],
                webAuths: [],
                isShow: false,
                curMember: '',
                curPerson:"",
                button: '个人权限',
                arr: [],
                webArr: [],
                page: 1,
                total: 1,
                value1: 1,
                checkId: 1,
                single: false,
                webSingle: false,
                showButton: true,
                name: [],
                webName: [],
                tabChange: 1,
                permissionUpdate: true,
                permissionRoles: true,
                permissionRoleUpdate: true,
            }
        },

        methods: {
            //切换tab标签
            tabsChange(val) {
                this.tabChange = val;
            },

            //pc全部选择
            handleCheckAll(val) {
                if (this.auths[val].indeterminate) {
                    this.auths[val].checkAll = true;
                } else {
                    this.auths[val].checkAll = !this.auths[val].checkAll;
                }
                this.auths[val].indeterminate = false;
                if (this.auths[val].checkAll) {
                    if (this.formItem.checkbox.length === 0) {
                        this.formItem.checkbox = this.auths[val].name;
                    } else {
                        this.formItem.checkbox.forEach(item => {
                            this.auths[val].name.map(items => {
                                if (item === items) {
                                    let index = this.formItem.checkbox.indexOf(item);
                                    this.formItem.checkbox.splice(index, 1);
                                }
                            })
                        })
                        this.formItem.checkbox = this.formItem.checkbox.concat(this.auths[val].name);
                    }
                } else {
                    if (this.formItem.checkbox === this.auths[val].name) {
                        this.formItem.checkbox = [];
                    } else {
                        for (var i = 0; i <= this.formItem.checkbox.length; i++) {
                            this.auths[val].name.forEach(items => {
                                if (this.formItem.checkbox[i] === items) {
                                    this.formItem.checkbox.splice(i, 1);
                                }
                                this.itemList.map(item => {
                                    if (item.children.length > 0) {
                                        item.children.map(val => {
                                            if (val.children.length > 0) {
                                                val.children.map(value => {
                                                    if (value.title === items) {
                                                        if (this.formItem.checkbox.indexOf(
                                                                val.title) >= 0) {
                                                            this.formItem.checkbox.splice(
                                                                this.formItem.checkbox
                                                                .indexOf(val.title),
                                                                1);
                                                        }
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            })
                        }
                    }
                }
            },

            //pc单独选择
            checkAllGroupChange(data) {
                let permission = [];
                this.itemList.map(item => {
                    item.children.map(items => {
                        if (items.children.length > 0) {
                            let arr = [];
                            items.children.map(res => {
                                if (data.indexOf(res.title) >= 0) {
                                    permission.push(res.name);
                                    arr.push(true);
                                } else {
                                    arr.push(false);
                                }
                            })

                            if (arr.indexOf(false) >= 0 && arr.indexOf(true) >= 0) { //不全选
                                this.auths[items.id].indeterminate = true;
                                this.auths[items.id].checkAll = false;
                                permission.push(items.name);
                                permission.push(item.name);
                                data.push(items.title);
                            } else if (arr.indexOf(false) < 0) { //全选
                                this.auths[items.id].indeterminate = false;
                                this.auths[items.id].checkAll = true;
                                permission.push(items.name);
                                permission.push(item.name);
                                data.push(items.title);
                            } else if (data.indexOf(items.title) >= 0 && arr.indexOf(true) < 0) { //选择
                                this.auths[items.id].indeterminate = true;
                                this.auths[items.id].checkAll = true;
                                permission.push(items.name);
                                data.push(items.title);
                            } else if (data.indexOf(items.title) < 0 && arr.indexOf(true) < 0) {
                                this.auths[items.id].indeterminate = false;
                                this.auths[items.id].checkAll = false;
                            }
                        }
                    })
                })
                this.arr = this.arr.concat(permission);
            },

            //是否显示按钮权限
            showPermiss(val) {
                this.checkId = val;
                this.itemList.forEach(item => {
                    if (item.id === val) {
                        item.access = !item.access;
                    }
                })
            },

            //web全部选择
            webhandleCheckAll(val) {
                console.log(this.webList);
                if (this.webAuths[val].indeterminate) {
                    this.webAuths[val].checkAll = false;
                } else {
                    this.webAuths[val].checkAll = !this.webAuths[val].checkAll;
                }
                this.webAuths[val].indeterminate = false;
                if (this.webAuths[val].checkAll) {
                    if (this.formItem.webCheckbox.length === 0) {
                        this.formItem.webCheckbox = this.webAuths[val].name;
                    } else {
                        this.formItem.webCheckbox.forEach(item => {
                            this.webAuths[val].name.map(items => {
                                if (item === items) {
                                    let index = this.formItem.webCheckbox.indexOf(item);
                                    this.formItem.webCheckbox.splice(index, 1);
                                }
                            })
                        })
                        this.formItem.webCheckbox = this.formItem.webCheckbox.concat(this.webAuths[val].name);
                    }
                } else {
                    if (this.formItem.webCheckbox === this.webAuths[val].name) {
                        this.formItem.webCheckbox = [];
                    } else {
                        for (var i = 0; i <= this.formItem.webCheckbox.length; i++) {
                            this.webAuths[val].name.forEach(items => {
                                if (this.formItem.webCheckbox[i] === items) {
                                    this.formItem.webCheckbox.splice(i, 1);
                                }
                                this.webList.map(item => {
                                    if (item.children.length > 0) {
                                        item.children.map(val => {
                                            if (val.title === items) {
                                                if (this.formItem.webCheckbox.indexOf(item.title) >=
                                                    0) {
                                                    this.formItem.webCheckbox.splice(this.formItem
                                                        .webCheckbox.indexOf(item.title), 1
                                                    );
                                                }
                                            }
                                        })
                                    }
                                })
                            })
                        }
                    }
                }
            },

            //web单独选择
            webcheckAllGroupChange(data) {
                console.log(data);
                console.log(1111);
                let permission = [];
                this.webList.map(item => {
                    let arr = [];
                    item.children.map(items => {
                        if (data.indexOf(items.title) >= 0) {
                            permission.push(items.name);
                            arr.push(true);
                        } else {
                            arr.push(false);
                        }
                    })
                    if (arr.indexOf(false) >= 0 && arr.indexOf(true) >= 0) {
                        this.webAuths[item.id].indeterminate = true;
                        this.webAuths[item.id].checkAll = false;
                        permission.push(item.name);
                        data.push(item.title);
                    } else if (arr.indexOf(false) < 0) {
                        this.webAuths[item.id].indeterminate = false;
                        this.webAuths[item.id].checkAll = true;
                        permission.push(item.name);
                        data.push(item.title);
                    } else if (data.indexOf(item.title) >= 0 && arr.indexOf(true) < 0) {
                        this.webAuths[item.id].indeterminate = true;
                        this.webAuths[item.id].checkAll = true;
                        permission.push(item.name);
                        data.push(item.title);
                    } else {
                        this.webAuths[item.id].indeterminate = false;
                        this.webAuths[item.id].checkAll = false;
                    }
                })
                this.webArr = this.webArr.concat(permission);
            },

            //crm单选
            //            crmcheckAllGroupChange(data) {
            //                let permission = [];
            //                for(let i=0; i<this.CrmList.length; i++)
            //                {
            //                    for(let j=0; j<data.length; j++)
            //                    {
            //                        if(this.CrmList[i].alias == data[j]){
            //                            permission.push(this.CrmList[i].name);
            //                        }
            //                    }
            //                }
            //                this.arr = this.arr.concat(permission);
            //            },

            //切换权限组与个人权限
            changeValue(val) {
                this.button = val;
                if (this.button == '权限组') {
                    this.getRoles();
                    this.page = 1;
                    this.arr = [];
                    this.webArr = [];
                }
                if (this.button == '个人权限') {
                    this.getMemberList();
                    this.page = 1;
                    this.arr = [];
                    this.webArr = [];
                }
            },

            //获取权限组
            getRoles() {
                this.$http.get(this.$api.ROLES + '?com_id' + '=' + this.$store.getters.userInfo.com_id, {}).then(res => {
                    if (res.data.status == 1) {
                        this.RolesList = res.data.data;
                        this.curMember = res.data.data[0].id;
                        this.getUserQx()
                    }
                }, err => {
                    // this.$Message.error('网络错误');
                });
            },

            //更改权限
            confirmUpdate(type) {
                this.$Spin.show();
                this.arr = [];
                this.webArr = [];
                this.checkAllGroupChange(this.formItem.checkbox);
                this.webcheckAllGroupChange(this.formItem.webCheckbox);
                if (type == 1) { //type=1 修改pc端权限
                    var data = [...new Set(this.arr)];
                } else if (type == 2) { //type=2 修改app权限
                    var data = [...new Set(this.webArr)];
                } else { //type=3 修改web端权限
                    var data = [...new Set(this.webArr)];
                }
                console.log(this.curPerson,this.curMember)
                let uidx = this.button === '个人权限'?this.curPerson:this.curMember;
                this.$http.post(this.$api.UPDATE_AUTH, {
                    uid: uidx,
                    data: data,
                    id: this.$store.getters.userInfo.id,
                    type: type,
                }).then(res => {
                    this.$Spin.hide();
                    if (res.data.status == 1) {
                        this.$Message.info('修改权限成功');
                        this.arr = [];
                        this.webArr = [];
                    } else {
                        this.arr = [];
                        this.webArr = [];
                        this.$Message.info('修改权限失败');
                    }

                }, err => {
                    this.arr = [];
                    this.webArr = [];
                    this.$Message.error('网络错误');
                });
            },

            // 更改权限权限组
            confirmRoles(type) {
                this.$Spin.show();
                this.arr = [];
                this.webArr = [];
                this.checkAllGroupChange(this.formItem.checkbox);
                this.webcheckAllGroupChange(this.formItem.webCheckbox);
                if (type == 1) { //type=1 修改pc端权限
                    var data = [...new Set(this.arr)];
                } else if (type == 2) { //type=2 修改app权限
                    var data = [...new Set(this.webArr)];
                } else { //type=3 修改web端权限
                    var data = [...new Set(this.webArr)];
                }
                this.$http.post(this.$api.ROLES_PERSSION, {
                    id: this.curMember,
                    data: data,
                    type: type,
                    uid: this.$store.getters.userInfo.id,
                }).then(res => {
                    this.$Spin.hide();
                    if (res.data.status == 1) {
                        this.arr = [];
                        this.webArr = [];
                        this.$Message.info('修改权限成功');
                    } else {
                        this.arr = [];
                        this.webArr = [];
                        this.$Message.info('修改权限失败');
                    }
                }, err => {
                    this.arr = [];
                    this.webArr = [];
                });
            },

            //修改权限组名称
            ok() {
                this.$http.post(this.$api.ROLESNAME, {
                    id: this.curMember,
                    name: this.formItem.input,
                    com_id: this.$store.getters.userInfo.com_id,
                    uid: this.$store.getters.userInfo.id,
                }).then(res => {
                    if (res.data.status == 1) {
                        this.getRoles();
                        this.$Message.info('修改成功');
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                })
            },

            //删除权限组
            del() {
                this.$http.delete(this.$api.ROLES + '/' + this.curMember + '?id=' + this.$store.getters.userInfo.id, {})
                    .then(res => {
                        if (res.data.status == 1) {
                            this.getRoles();
                            this.modal2 = false;
                            this.$Message.info('删除成功');
                        } else {
                            this.$Message.error('删除失败');
                        }
                    }, err => {
                        this.$api.errcallback(err)
                    })
            },

            //显示修改，删除按钮
            titleShow() {
                this.isShow = true;
            },

            //权限列表
            getAuth() {
                this.$http.get(this.$api.GET_AUTH).then(res => {
                    if (res.data.status == 1) {
                        this.name = res.data.name;
                        this.webName = res.data.webName;
                        this.itemList = res.data.data;    //应用端权限板块
                        this.webList = res.data.web;      //web端权限板块
                        console.log(res.data);
                        //                        this.CrmList = res.data.crm;
                        this.pcList();
                        this.webLists();
                    }
                    this.getMemberList();
                    this.getRoles();
                }, err => {
                });
            },

            //处理pc权限数据
            pcList() {
                let auth = [];
                let auths = [];
                if (this.itemList.length > 0)
                    this.itemList.forEach(item => {
                        auth.push(item.title);
                        if (item.children.length > 0) {
                            item.children.forEach(items => {
                                let arr = [];
                                let result = [];
                                if (items.children.length > 0) {
                                    items.children.forEach(res => {
                                        arr.push(res.title);
                                    })
                                }
                                result.name = arr;
                                result.indeterminate = false;
                                result.checkAll = false;
                                auths[items.id] = result;
                            })
                        }
                    });
                this.auth = auth;
                this.auths = auths;
            },

            //处理web权限数据
            webLists() {
                let auth = [];
                let auths = [];
                if (this.webList.length > 0)
                    this.webList.forEach(item => {
                        auth.push(item.title);
                        let arr = [];
                        let result = {};
                        if (item.children.length > 0) {
                            item.children.forEach(items => {
                                arr.push(items.title);
                            })
                        }

                        result.name = arr;
                        result.indeterminate = false;
                        result.checkAll = false;
                        auths[item.id] = result;
                    });
                this.webAuth = auth;
                this.webAuths = auths;
            },

            /*
                名称: 获取成员列表
                类型: 业务函数、ajax函数
                备注: 备注
            */
            getMemberList(page) {
                if (page) {
                    this.page = page;
                }
                this.$http.post(this.$api.USER_INDEX, {
                    com_id: this.$store.getters.userInfo.com_id,
                    limit: 15,
                    page: this.page
                }).then(res => {
                    if (res.data.status == 1) {
                        if (typeof res.data.data == 'object') {
                            this.memberList = res.data.data.data;
                            if (page) {
                                this.curMember = this.memberList[0].id;
                            } else {
                                this.curMember = this.$route.params.id ? this.$route.params.id : this.memberList[
                                    0].id;
                            }
                            this.getUserQx();
                            this.total = res.data.data.total;
                        }
                    }
                }, err => {
                    this.$api.errcallback(err)
                });
            },

            //切换用户,组
            changeMember(id) {
                this.arr = [];
                this.webArr = [];
                this.curMember = id;
                this.getUserQx();
                this.isShow = false;
            },

            /*
                名称: 修改用户角色
                类型: 业务函数
                备注:
                    id：权限组成员id
            */
            changeRole(id) {
                this.arr = [];
                this.webArr = [];
                // 1、设置选中的权限组成员id
                this.curMember = id;
                // 2、获取选中的权限组成员的权限,赋给当前选中的用户
                this.getPowerGroupPermission();
                this.isShow = false;
            },

            /*
                名称: 获取权限组成员的权限
                类型: ajax函数
                备注:
                    permArr:pc客户端权限
                    webPerArr:web端权限
            */
            getPowerGroupPermission() {
                this.$http.get(this.$api.ROLES + '/' + this.curMember).then(res => {
                    if (res.data.status == 1) {
                        const temArr = [];
                        const webArr = [];
                        let qx = res.data.data;
                        let webQx = res.data.webData;
                        qx.map(function (i) {
                            temArr.push(i.alias)
                        })
                        webQx.map(function (i) {
                            webArr.push(i.alias)
                        });
                        let permArr = [...new Set(temArr)];
                        let webPerArr = [...new Set(webArr)];
                        // this.checkAllGroupChange(permArr);
                        // this.webcheckAllGroupChange(webPerArr);
                        // this.crmcheckAllGroupChange(permArr);
                        this.formItem.checkbox = permArr;
                        this.formItem.webCheckbox = webPerArr;
                    }
                })
            },

            //获取权限
            getUserQx() {
                if (this.button == '个人权限') {
                    this.curPerson = this.curMember;
                    this.$http.get(this.$api.ADD_USER + '/' + this.curMember).then(res => {
                        if (res.data.status == 1) {
                            const temArr = [];
                            const webArr = [];
                            const qx = res.data.data.permissions;
                            const webQx = res.data.data.webPermission;
                            qx.map(function (i) {
                                temArr.push(i.alias)
                            });
                            webQx.map(function (i) {
                                webArr.push(i.alias)
                            });
                            let permArr = [...new Set(temArr)];
                            let webPerArr = [...new Set(webArr)];
                            this.checkAllGroupChange(permArr);
                            this.webcheckAllGroupChange(webPerArr);
                            //  this.crmcheckAllGroupChange(permArr);
                            this.formItem.checkbox = permArr;
                            this.formItem.webCheckbox = webPerArr;
                        } else {
                            let permArr = [];
                            this.checkAllGroupChange(permArr);
                            this.webcheckAllGroupChange(permArr);
                            // this.crmcheckAllGroupChange(permArr);
                            this.formItem.checkbox = permArr;
                            this.formItem.webCheckbox = permArr;
                        }
                    })
                } else {
                    this.$http.get(this.$api.ROLES + '/' + this.curMember).then(res => {
                        if (res.data.status == 1) {
                            const temArr = [];
                            const webArr = [];
                            let qx = res.data.data;
                            let webQx = res.data.webData;
                            qx.map(function (i) {
                                temArr.push(i.alias)
                            })
                            webQx.map(function (i) {
                                webArr.push(i.alias)
                            });
                            let permArr = [...new Set(temArr)];
                            let webPerArr = [...new Set(webArr)];
                            this.checkAllGroupChange(permArr);
                            this.webcheckAllGroupChange(webPerArr);
                            // this.crmcheckAllGroupChange(permArr);
                            this.formItem.checkbox = permArr;
                            this.formItem.webCheckbox = webPerArr;
                        } else {
                            let permArr = [];
                            this.checkAllGroupChange(permArr);
                            this.webcheckAllGroupChange(permArr);
                            // this.crmcheckAllGroupChange(permArr);
                            this.formItem.checkbox = permArr;
                        }
                    })
                }

            },
            //跳转到添加权限组
            addRoutes() {
                this.$router.push({
                    name: 'routeAdd'
                })
            },
            //处理权限（部门自定义属性不能解决的属性）
            permissionHandle() {
                let permissionList = sessionStorage.getItem('permission');
                if (!permissionList.includes('web_permission_update')) {
                    this.permissionUpdate = false;
                }
                if (!permissionList.includes('web_permission_roles')) {
                    this.permissionRoles = false;
                }
                if (!permissionList.includes('web_permission_role_update')) {
                    this.permissionRoleUpdate = false;
                }

            }
        },
        watch: {
            'memberList': function (val) {},
            'curMember': function (val) {},
            'single': function (val) {
                if (val === false) {
                    var data = [];
                    this.checkAllGroupChange(data);
                    this.formItem.checkbox = data;
                } else {
                    var data = this.name;
                    this.checkAllGroupChange(data);
                    this.formItem.checkbox = data;
                }
            },
            'webSingle': function (val) {
                if (val === false) {
                    var data = [];
                    this.webcheckAllGroupChange(data);
                    this.formItem.webCheckbox = data;
                } else {
                    var data = this.webName;
                    this.webcheckAllGroupChange(data);
                    this.formItem.webCheckbox = data;
                }
            },
        },
        beforeMount: function () {
            this.page = this.$route.params.page ? this.$route.params.page : 1;
            this.button = this.$route.params.button ? this.$route.params.button : '个人权限';
            this.getAuth();
            this.permissionHandle();
        },
    }

</script>

<style scoped>
    li {
        list-style-type: none;
    }

    .rolesModel {
        position: relative;
        right: -150px;
        color: #333;
        background-color: #fff;
        width: 80px;
        height: 60px;
        border-radius: 3px;
        border: 1px solid #dddee1;
    }

    .rolesModel div {
        height: 30px;
        font-size: 14px;
        padding-left: 5px;
        display: flex;
        align-items: center;
        /*justify-content: center;*/

    }

    .content .conLeftTwo {
        overflow: visible;
    }

    /* 权限选项字体修改 */
    .ivu-checkbox-wrapper {
        font-size: 13px;
    }

    .conLeftTwo {
        height: 654px;
        position: relative;
        overflow: hidden;
        border-right: 1px dotted #DCE1E6;
    }

    .top {
        padding: 12px 10px;
        border-bottom: 1px solid #DCE1E6;
        text-align: center;
    }

    .ivu-btn-group {
        width: 100%;
    }

    .hideCheck {
        display: none;
    }

    .showCheck {
        display: block;
    }

    .ivu-btn-group button {
        width: 50%;
        height: 26px;
        padding: 0;
        border: 1px solid #2d8cf0;
    }

    .main {
        padding: 12px 6px;
    }

    .main li {
        padding: 5px 10px;
        font-size: 13px;
        height: 28px;
        cursor: pointer;
    }

    .main li.selected {
        background: #2d8cf0;
        color: #fff;
    }

    .main li i {
        margin-left: 2px;
        margin-right: 8px;
        font-size: 14px;
        line-height: 21px;
        vertical-align: middle;
    }

    .conRight {
        padding: 10px 26px;
    }

    .mainNav {
        height: 34px;
        border-bottom: 1px solid #ccc;
    }

    .mainContent h3 {
        height: 26px;
        font-weight: 400;
        margin-top: 14px;
    }

    .topName {
        font-size: 14px;
        padding: 10px 0;
        border-bottom: 1px solid #DCE1E6;
        margin-bottom: 10px;
    }

    .topName span {
        font-size: 12px;
        color: #ccc;
        margin-left: 10px;
    }

    .ivu-form-item {
        margin-bottom: 10px;
    }

    .yuce .ivu-form-item {
        margin-bottom: 0;
    }

    .kehuGuanli .ivu-form-item {
        height: 33px;
        margin-bottom: 0;
    }

    .iv-icon-down {
        float: right;
        margin-top: 1px;
        margin-right: -15px;
        cursor: pointer;
        display: inline;
        width: 40px;
        height: 28px;
        line-height: 28px;
    }

    .permissionTop {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .title-lv2 {
        display: inline;
        font-weight: 500;
        border-bottom: 2px solid #2d8cf0;
        font-size: 16px;
        padding: 6px 15px;
        color: #2d8cf0;
        cursor: pointer;
    }

    .title-lv3 {
        display: inline;
        font-weight: 500;
        font-size: 16px;
        padding: 6px 15px;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/components/permission/permission.vue